module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.message))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68827489!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/form/ValidationMessage.vue
// module id = 761
// module chunks = 2